module.exports = __webpack_public_path__ + "img/diaceutics-brand-gradients-02.428e0031.png";